export default "__VITE_ASSET__6b065fb0__"